import { render, staticRenderFns } from "./rightlist.vue?vue&type=template&id=0de50a24&scoped=true&"
import script from "./rightlist.vue?vue&type=script&lang=js&"
export * from "./rightlist.vue?vue&type=script&lang=js&"
import style0 from "./rightlist.vue?vue&type=style&index=0&id=0de50a24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de50a24",
  null
  
)

export default component.exports